const DEVICE_ID_KEY = 'sa_rtdb_device_id';

// A stable per-browser id so presence/pages for one tab can be distinguished from
// another device or team member. Persisted in localStorage.
export const getOrCreateDeviceId = (): string => {
  if (typeof window === 'undefined') return 'ssr';
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);
    if (existing) return existing;
    const deviceId = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(DEVICE_ID_KEY, deviceId);
    return deviceId;
  } catch {
    // localStorage unavailable (e.g. some embed sandboxes) — fall back to ephemeral id.
    return `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
};

// Best-effort context label for the app presence node.
export const getClientContext = (): 'web' | 'iframe-embed' => {
  if (typeof window === 'undefined') return 'web';
  try {
    return window.self !== window.top ? 'iframe-embed' : 'web';
  } catch {
    // Cross-origin access to window.top throws — that itself means we're embedded.
    return 'iframe-embed';
  }
};
